import React, {useEffect, useState} from 'react'
import {useMutation} from 'react-query'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import moment from 'moment'
import Divider from '@mui/material/Divider'
import {Grid, Menu, MenuItem, Select, Stack, Typography} from '@mui/material'
import {
  AccessTime,
  Approval as ApprovalIcon,
  BookOnline,
  Comment,
  Face,
  Info,
  MoreVert as MoreVertIcon,
  Stop as StopIcon,
  Toc as TocIcon,
} from '@mui/icons-material'
import withWidth from '@mui/material/Hidden/withWidth'
import parse from 'html-react-parser'
import {
  Accordion,
  Button,
  CustomEditorContent,
  DetailedLayout,
  Dialog as AlertDialog,
  Editor,
  FileDeleteDialog,
  FilePreviewDialog,
  IconButton,
  Loading,
  ServerSideAutocomplete,
  StringAvatar,
  TextBox,
  TextField,
} from 'finsys-webcomponent'
import {saveAs} from 'file-saver'
// import * as XLSX from 'xlsx-js-style'
import {setBreadcrumbRecordName} from 'store/actions'
import useDataFetching from 'hoc/UseDataFetching'
import MergeIcon from 'assets/icons/merge.png'
import SplitIcon from 'assets/icons/split.png'
import {useSnackBar} from 'hoc/SnackbarHandler'
import {useAuth} from 'hoc/AuthContext'
import {queryClient} from 'hoc/ReactQuery'
import {
  APPROVAL_MATRIX_PAGE_NAME,
  dateTimeFormat,
  dateTimeFormatTableForFile,
  HQ_ROLE_ID,
  STATUS_COMPLETED,
  STATUS_DRAFT,
  STATUS_PENDING_SECOND_APPROVED,
  STATUS_REJECTED,
  STATUS_SUBMITTED,
  STATUS_VERIFIED,
  STATUS_WITHDRAWN,
} from '_helper/_constants'
import {FileUpload} from 'components/_Common/FileUpload'
import {
  deleteAttachment,
  downloadAttachment,
  getPOAAttachments,
  previewAttachment,
  uploadRequestAttachment,
} from 'api/TS/query/AttachmentQueries'
import {formatCellValue, renderCellComponent} from 'components/Tables/_helper'
import {POATable} from 'components/Tables/POATable'
import {
  fetchPOAEditSummary,
  fetchPOASummary,
  rejectPOA,
  savePOA,
  submitPOA,
  withdrawPOA,
} from 'api/TS/query/POAEditQueries'
import {retrievePageFunctionAccess} from '_helper/_authHelper'
import {
  fetchComments,
  FetchCommentsType,
  saveComments,
} from 'api/TS/query/POACommentQueries'
import {
  useFetchEntities,
  useFetchPOACategory,
  useFetchSegment,
} from 'components/_Utils/UseFetchFunctions'
import {fetchUsers} from 'api/TS/query/_CommonQueries'
import {toMergeField} from 'pages/POA/_constants'
import StatusChip from 'components/InternalRequest/Forms/_Common/StatusChip'
import {Reject} from 'components/ActionButtonDialog/Reject'
import {getUserRole} from 'localstorage/UserRole'
import {Withdraw} from 'components/ActionButtonDialog/Withdraw'
import {getStyledCellValue} from 'components/_Utils'
import {ImportExcel} from 'components/ImportExcel'
import {usePOAImportColumn} from '../Column'

import * as ExcelJS from 'exceljs'

/**
 * To retrieve request comments
 * @param id
 * @return {{isError: false | true, data: FetchCommentsType, isPreviousData: boolean, loading: boolean | undefined, error: unknown}}
 */
function useGetRequestComments(id: number): FetchCommentsType {
  return useDataFetching(`poa-request-${id}-comments`, () => fetchComments({id}))
}

/**
 * To retrieve request attachment
 * @param id
 * @return {{isError: false | true, data: FetchCommentsType, isPreviousData: boolean, loading: boolean | undefined, error: unknown}}
 */
function useGetRequestAttachments(id: number) {
  return useDataFetching(`poa-request-${id}-attachments`, () =>
    getPOAAttachments({poaRequestId: id})
  )
}

function Edit() {
  let {entity, segment, country, requestId} = useParams()
  const {user} = useAuth()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [anchorEl, setAnchorEl] = useState(null)
  const [openImport, setOpenImport] = useState({
    open: false,
  })
  const {setSnackBar} = useSnackBar()
  const [commentField, setCommentField] = useState(undefined)
  const [isFileUploading, setIsFileUploading] = useState(false)
  const [requestStatus, setRequestStatus] = useState('Draft')
  const [serverPaginationResult, setServerPaginationResult] = useState({
    rowData: [],
    tempObjIndex: {},
    totalPages: 0,
    totalCount: 0,
    toNextPage: 0,
    toPreviousPage: 0,
    currentPage: 1,
  })
  const [entitiesObj, setEntitiesObj] = useState({})
  const [categoriesObj, setCategoriesObj] = useState({})

  const [editable, setEditable] = useState(true)
  const [currentOrder, setCurrentOrder] = useState(0)
  const [selectedCell, setSelectedCell] = useState([])
  const [toEditCell, setToEditCell] = useState(null)
  const [toMutateEntityRow, setToMutateEntityRow] = useState(null)
  const [fullScreenDialogConst, setFullScreenDialogConst] = useState({
    open: false,
    type: null,
  })
  const [menuObject, setMenuObject] = useState(null)
  const [openAlertDialog, setOpenAlertDialog] = useState({
    open: false,
  })
  const [functionAccess, setFunctionAccess] = useState([])
  const [isCallingApi, setIsCallingApi] = useState({
    loading: false,
    type: null,
  })
  const [openDeleteFileDialog, setOpenDeleteFileDialog] = useState({
    open: false,
    index: null,
  })
  const [filePreviewDialog, setFilePreviewDialog] = useState({
    open: false,
    value: null,
  })
  const [actionDialog, setActionDialog] = useState({
    type: null,
    value: null,
    open: false,
    isDisabled: false,
    isLoading: false,
  })
  const [isChangeSummaryExpanded, setIsChangeSummaryExpanded] = useState(true)
  const [generalDetails, setGeneralDetails] = useState({
    approver: null,
    changeSummary: '',
    requestedBy: null,
    lastUpdatedOn: null,
    entityCode: null,
  })
  const [entityName, setEntityName] = useState(null)
  const [cellMutation, setCellMutation] = useState(null)

  const {loading: isEntitiesLoading, data: entities} = useFetchEntities()
  const {loading: isCategoriesLoading, data: categories} = useFetchPOACategory()
  const {loading: isCommentsLoading, data: comments} = useGetRequestComments(requestId)
  const {loading: isAttachmentsLoading, data: attachments} =
    useGetRequestAttachments(requestId)
  const {loading: isSegmentsLoading, data: segments} = useFetchSegment()
  const poaImportColumn = usePOAImportColumn({
    country,
    categories: categories?.map(({category}) => category),
    segments: segments?.map(({value}) => value),
    entities: entities
      ?.filter(({country_id}) => country_id === country)
      .map(({entity_code}) => entity_code),
  })

  /**
   * To retrieve POA summary by request id else entity
   */
  const {loading: isSummaryLoading, data: summaryData} = useDataFetching(
    [`POA-${entity}`, entity, requestId],
    () =>
      requestId
        ? fetchPOAEditSummary(requestId)
        : fetchPOASummary({
            segment,
            entity,
            country,
          }),
    {refetchOnWindowFocus: false}
  )

  /**
   * To redirect non hq user to forbidden page
   */
  useEffect(() => {
    if (getUserRole().role !== HQ_ROLE_ID) {
      navigate('/Forbidden')
    }
  }, [])

  /**
   * Determine which function does user have access to
   */
  useEffect(() => {
    if (functionAccess.length === 0) {
      retrievePageFunctionAccess(APPROVAL_MATRIX_PAGE_NAME, setFunctionAccess)
      return
    }

    if (functionAccess === 'FORBIDDEN') {
      navigate('/Forbidden')
    }
  }, [functionAccess])

  useEffect(() => {
    if (entities?.length > 0) {
      let entitiesObj = entities.reduce((acc, entity) => {
        if (!acc[entity['entity_code']]) {
          acc[entity['entity_code']] = entity
        }

        return acc
      }, {})

      setEntitiesObj(entitiesObj)
    }
  }, [entities])

  useEffect(() => {
    if (categories?.length > 0) {
      let categoriesObj = categories.reduce((acc, entity) => {
        if (!acc[entity['category']]) {
          acc[entity['category']] = entity
        }

        return acc
      }, {})

      setCategoriesObj(categoriesObj)
    }
  }, [categories])

  const columns = [
    {
      name: '',
      fieldName: 'tableMenu',
      component: ({entityId, dataIndex}) => (
        <IconButton
          title="Modify Row"
          handleOnClick={(event) => {
            handleTableMenuClick(event, entityId, dataIndex)
          }}
        >
          <TocIcon fontSize={'small'} />
        </IconButton>
      ),
    },
    {
      name: 'Segment',
      fieldName: 'segment_id',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        if (disabled) {
          return value
        }

        return (
          <Select
            value={value}
            displayEmpty
            variant={'outlined'}
            style={{width: '100%', fontSize: '0.9em'}}
            inputProps={{'aria-label': 'Without label'}}
          >
            {segments?.map(({value}, index) => {
              return (
                <MenuItem
                  key={index}
                  value={value}
                  onClick={() =>
                    handleOnSelectSegmentCellClick(
                      value,
                      entityId,
                      dataIndex,
                      rowSpanName,
                      fieldName
                    )
                  }
                >
                  {value}
                </MenuItem>
              )
            })}
          </Select>
        )
      },
    },
    {
      name: 'Category',
      fieldName: 'category',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        if (disabled) {
          return value.category
        }

        return (
          <Select
            value={value.poa_category_id}
            displayEmpty
            variant={'outlined'}
            style={{width: '100%', fontSize: '0.9em'}}
            inputProps={{'aria-label': 'Without label'}}
          >
            {categories.map((value, index) => {
              return (
                <MenuItem
                  style={{fontSize: '0.9em'}}
                  key={index}
                  value={value.poa_category_id}
                  onClick={() =>
                    handleOnSelectCategoryCellClick(
                      value,
                      entityId,
                      dataIndex,
                      rowSpanName,
                      fieldName
                    )
                  }
                >
                  {value.category}
                </MenuItem>
              )
            })}
          </Select>
        )
      },
    },
    {
      name: 'Sub Category',
      fieldName: 'sub_category',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return (
          <CustomEditorContent
            disabled={disabled}
            customEditor={Editor}
            value={value}
            autoFocus={'end'}
            handleOnChange={(value) => {
              setCellMutation({
                value,
                entityId,
                dataIndex,
                rowSpanName,
                fieldName,
              })
            }}
          />
        )
      },
    },
    {
      name: 'Forms To Be Signed',
      fieldName: 'forms_to_be_signed',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return (
          <CustomEditorContent
            disabled={disabled}
            customEditor={Editor}
            value={value}
            autoFocus={'end'}
            handleOnChange={(value) => {
              setCellMutation({
                value,
                entityId,
                dataIndex,
                rowSpanName,
                fieldName,
              })
            }}
          />
        )
      },
    },
    {
      name: 'Risk Level',
      fieldName: 'risk_level',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
    {
      name: 'Internal Approval Requirement',
      fieldName: 'internal_approval_requirement',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
    {
      name: 'Internal Approval(*)',
      fieldName: 'internal_approval',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
    {
      name: 'Principal',
      fieldName: 'principal',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
    {
      name: 'Agent',
      fieldName: 'agent',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
    {
      name: 'Remarks',
      fieldName: 'remarks',
      component: ({value, entityId, dataIndex, rowSpanName, fieldName, disabled}) => {
        return getComponent({
          disabled,
          value,
          entityId,
          dataIndex,
          rowSpanName,
          fieldName,
        })
      },
    },
  ]

  /**
   * To return the common component
   * @param disabled
   * @param value
   * @param entityId
   * @param dataIndex
   * @param rowSpanName
   * @param fieldName
   * @return {JSX.Element}
   */
  const getComponent = ({
    disabled,
    value,
    entityId,
    dataIndex,
    rowSpanName,
    fieldName,
  }) => {
    if (disabled) return renderCellComponent(value)

    return (
      <TextBox
        customEditor={Editor}
        value={value}
        handleOnChange={(value) =>
          setCellMutation({
            value,
            entityId,
            dataIndex,
            rowSpanName,
            fieldName,
          })
        }
        autoFocus={'end'}
      />
    )
  }

  /**
   * To handle Entity menu - to add new rows
   * @return {JSX.Element}
   */
  const handleEntityMenu = () => (
    <IconButton
      title="Modify Row"
      handleOnClick={(event) => handleTableMenuClick(event, entity)}
    >
      <TocIcon fontSize={'small'} />
    </IconButton>
  )

  /**
   * To set a default entity is the rowData return empty array
   */
  useEffect(() => {
    if (entities && !entityName) {
      const entityDetail = entities.find((entityObj) => entityObj.entity_id == entity)
      setEntityName(entityDetail?.entity_name)
      setGeneralDetails({
        ...generalDetails,
        entityCode: entityDetail?.entity_code,
      })
    }

    if (entityName && serverPaginationResult.rowData?.length === 0) {
      setServerPaginationResult((prevState) => ({
        ...prevState,
        rowData: {
          [entity]: {
            data: [],
            name: entityName,
            request_type: 'add',
          },
        },
      }))
    }
  }, [entities, serverPaginationResult.rowData, entityName])

  /**
   * To set breadcrumb nav
   */
  useEffect(() => {
    let currentNav = ''

    if (!generalDetails.entityCode) {
      return
    }

    if (requestId) {
      // currentNav = `${country.toUpperCase()} - ${segment.toUpperCase()} - ${generalDetails.entityCode.toUpperCase()} Edit Request ${
      currentNav = `${country.toUpperCase()}} Edit Request ${requestId ?? ''}`
    } else {
      // currentNav = `Create Request for ${country.toUpperCase()} - ${segment.toUpperCase()} - ${generalDetails.entityCode.toUpperCase()}`
      currentNav = `Create Request for ${country.toUpperCase()}`
    }

    dispatch(
      setBreadcrumbRecordName({
        [location.pathname]: currentNav,
      })
    )
  }, [generalDetails.entityCode])

  /**
   * To set the row value after cell mutation
   */
  useEffect(() => {
    if (cellMutation) {
      const entityId = cellMutation.entityId
      const value = cellMutation.value
      const dataIndex = cellMutation.dataIndex
      const rowSpanName = cellMutation.rowSpanName
      const fieldName = cellMutation.fieldName

      let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]

      for (
        let i = dataIndex;
        i <
        (dataIndex === 0
          ? modifiedRowData[dataIndex][rowSpanName]
          : modifiedRowData[dataIndex][rowSpanName] + dataIndex);
        i++
      ) {
        if (cellMutation.isCategory) {
          modifiedRowData[i].poa_category_id = value.poa_category_id
          modifiedRowData[i][fieldName] = value.category
        } else {
          modifiedRowData[i][fieldName] = value
        }
      }

      setServerPaginationResult((prevState) => ({
        ...prevState,
        rowData: {
          ...prevState.rowData,
          [entityId]: {
            ...prevState.rowData[entityId],
            data: modifiedRowData,
          },
        },
      }))
    }
  }, [cellMutation])

  /**
   * To mutate the cell value for select
   * @param value
   * @param entityId
   * @param dataIndex
   * @param rowSpanName
   */
  const handleOnSelectCategoryCellClick = (value, entityId, dataIndex) => {
    setCellMutation({
      value: value,
      entityId,
      dataIndex,
      rowSpanName: 'categoryRowSpan',
      fieldName: 'category',
      isCategory: true,
    })

    setToEditCell(null)
  }

  /**
   * To mutate the cell value for select
   * @param value
   * @param entityId
   * @param dataIndex
   * @param rowSpanName
   */
  const handleOnSelectSegmentCellClick = (value, entityId, dataIndex) => {
    setCellMutation({
      value: value,
      entityId,
      dataIndex,
      rowSpanName: 'segment_idRowSpan',
      fieldName: 'segment_id',
    })

    setToEditCell(null)
  }

  /**
   * To set requestStatus if currentOrder updates
   */
  useEffect(() => {
    if (currentOrder) {
      setRequestStatus(getRequestStatus(currentOrder))
    }
  }, [currentOrder])

  /**
   * To get request status by currentOrder
   * @param currentOrder
   * @return {string}
   */
  const getRequestStatus = (currentOrder) => {
    switch (currentOrder) {
      case 1:
        return STATUS_SUBMITTED
      case 2:
        return STATUS_VERIFIED
      case 3:
      case 4:
        return STATUS_PENDING_SECOND_APPROVED
      case 99:
        return STATUS_COMPLETED
      case 100:
        return STATUS_REJECTED
      case 101:
        return STATUS_WITHDRAWN
      default:
        return STATUS_DRAFT
    }
  }
  /**
   * To update the table data and format the data for the table to consume
   */
  useEffect(() => {
    if (summaryData) {
      // if we have requestId we need to take the data from summary
      // then compare it with requestID
      const data = requestId ? summaryData.summary : summaryData
      let modifiedData = []
      let newData = {}

      // if its request ID we need to concat it and replaced with details....
      if (requestId) {
        setEditable(summaryData.editable === 'Y')
        setCurrentOrder(parseInt(summaryData.current_order))
        setGeneralDetails({
          ...generalDetails,
          requestedBy: summaryData.created_by,
          lastUpdatedOn: summaryData.last_update_date_format,
          changeSummary: summaryData.change_summary,
          approver: {
            full_name: summaryData.approve_2_fullname,
            email: summaryData.approve_2,
          },
        })

        modifiedData = summaryData.request_detail.reduce(
          (previousValue, currentValue, index) => {
            if (!currentValue.poa_id) {
              //we gonna push the result to
              if (!newData[currentValue.entity_id]) {
                newData[currentValue.entity_id] = []
              }
              newData[currentValue.entity_id].push(currentValue)
              return previousValue
            }

            return {
              ...previousValue,
              [currentValue.poa_id]: {
                index,
                ...currentValue,
              },
            }
          },
          {}
        )
      }
      // we need to loop one round to add the data in
      data.forEach((row, index) => {
        // we need to push new data in too..
        if (row.entity_id !== data[index + 1]?.entity_id) {
          const entityID = row.entity_id

          if (newData[entityID]) {
            for (const newRow of newData[entityID]) {
              data.splice(index + 1, 0, newRow)
            }
            //after that we shall delete it
            newData[entityID] = []
          }
        }
      })

      // next we need to loop the left over new data
      for (const [key, value] of Object.entries(newData)) {
        if (newData[key]) {
          for (const newRow of newData[key]) {
            data.push(newRow)
          }
        }
      }

      // if data is empty will jus push all new data in
      if (data.length === 0 && requestId) {
        summaryData.request_detail.forEach((row) => {
          data.push(row)
        })
      }

      // upon save/submission, reset renderbuttons state to null
      setIsCallingApi({
        loading: false,
        type: null,
      })

      const {tempSummaryData, existingObjIndex} = handleToMergeField(modifiedData, data)

      // for pagination: cnt no. of distinct entity_id, total records by country
      const distinctEntityCount = Object.keys(tempSummaryData).length
      const totalRecordsCount = Object.keys(summaryData).length

      setServerPaginationResult({
        rowData: tempSummaryData,
        tempObjIndex: existingObjIndex,
        totalPages: distinctEntityCount ?? 0,
        //< 10 ? 1 : Math.floor(distinctEntityCount / 10), //round page no. down to nearest int
        totalCount: totalRecordsCount ?? 0,
        toNextPage: distinctEntityCount !== 0 ? 2 : 0, // set no. for initial state
        toPreviousPage: distinctEntityCount > 0 ? 1 : 0, // set no. for initial state
        currentPage: 1,
      })
    }
  }, [summaryData])

  const handleToMergeField = (modifiedData, data) => {
    // to retain the order index
    let orderIndex = 0
    // we need to extract threshold and matrix first
    let tempSummaryData = []
    let currentEntity = null
    let currentEntityIndex = 0
    let existingObjIndex = {}
    data.forEach((row, index) => {
      // lets set the row if its empty we jus set it to 'edit'
      row.request_type = row.request_type ?? 'edit'
      // whatever it is we need to group it based by entity
      let newSummaryData = {...tempSummaryData}

      if (!newSummaryData[row.entity_id]) {
        newSummaryData[row.entity_id] = {
          request_type: 'add',
          name: row.entity_name,
          orderIndex: orderIndex,
          data: [],
        }
        orderIndex++
      }

      // we check if it exist then replace...
      if (modifiedData[row.poa_id]) {
        const modifiedCell = modifiedData[row.poa_id]

        toMergeField.forEach((fieldName) => {
          if (fieldName === 'entity') {
            return
          }

          if (fieldName === 'poa_category_id' && fieldName === undefined) {
            console.log('fieldName ', fieldName, ' not defined')
            return
          }

          row[`previous_${fieldName}`] = row[fieldName] ?? ''
          row[fieldName] = modifiedCell[fieldName]
          row.request_type = modifiedCell.request_type
        })
      }

      // the code below is executed if its not a header
      // we will merge it only if they got the same entity as the previous index
      let ableToMerge = undefined
      if (currentEntity !== row.entity_id) {
        currentEntity = row.entity_id
        currentEntityIndex = 0
        ableToMerge = false
      } else {
        ableToMerge = true
        currentEntityIndex++
      }

      //to set the index
      if (row.poa_id) {
        existingObjIndex[row.poa_id] = {
          entity_id: row.entity_id,
          index: currentEntityIndex,
        }
      }

      // we will loop the field to set its rowSpan and index and compare if its merge-able
      toMergeField.forEach((fieldName) => {
        let tempArray = [...newSummaryData[row.entity_id].data]
        let rowSpanIndex = currentEntityIndex
        let rowSpan = 1

        if (ableToMerge) {
          const prevIndex = currentEntityIndex - 1
          // if previous is a add / delete we cannot merge
          // if current row is a edit or delete we cannot merge

          // original
          //   if (
          //     tempArray[prevIndex].request_type === row.request_type &&
          //     formatCellValue(tempArray[prevIndex][fieldName]).localeCompare(
          //       formatCellValue(row[fieldName])
          //     ) === 0 &&
          //     formatCellValue(tempArray[prevIndex][`previous_${fieldName}`]).localeCompare(
          //       formatCellValue(row[`previous_${fieldName}`] ?? row[`${fieldName}`])
          //     ) === 0
          //   ) {
          //     // we will add +1 to the previous rowSpan based on the row span index
          //     tempArray[tempArray[prevIndex][`${[fieldName]}RowSpanIndex`]][
          //       `${[fieldName]}RowSpan`
          //     ]++

          //     // update the current rowSpanIndex & rowSpan to the previous row index
          //     rowSpanIndex = tempArray[prevIndex][`${[fieldName]}RowSpanIndex`]
          //     rowSpan = 0
          //   }
          // }

          // handle existing tickets which may not have poa_category_id field
          if (fieldName === 'poa_category_id' && fieldName === undefined) {
            console.log('fieldName ', fieldName, ' not defined')
            return
          }

          if (
            fieldName === 'poa_category_id' && typeof row[fieldName] === 'number'
              ? tempArray[prevIndex].request_type === row.request_type &&
                formatCellValue(tempArray[prevIndex][fieldName]) ===
                  formatCellValue(row[fieldName]) && // Direct comparison for integers
                formatCellValue(tempArray[prevIndex][`previous_${fieldName}`]) ===
                  formatCellValue(row[`previous_${fieldName}`] ?? row[`${fieldName}`]) // Direct comparison for integers
              : tempArray[prevIndex].request_type === row.request_type &&
                formatCellValue(tempArray[prevIndex][fieldName]).localeCompare(
                  formatCellValue(row[fieldName])
                ) === 0 && // comparison for str
                formatCellValue(
                  tempArray[prevIndex][`previous_${fieldName}`]
                ).localeCompare(
                  formatCellValue(row[`previous_${fieldName}`] ?? row[`${fieldName}`])
                ) === 0
          ) {
            // we will add +1 to the previous rowSpan based on the row span index
            tempArray[tempArray[prevIndex][`${[fieldName]}RowSpanIndex`]][
              `${[fieldName]}RowSpan`
            ]++

            // update the current rowSpanIndex & rowSpan to the previous row index
            rowSpanIndex = tempArray[prevIndex][`${[fieldName]}RowSpanIndex`]
            rowSpan = 0
          }
        }

        // if this is the first record we shall instantiate the rowSpan & rowIndex for the field
        if (!tempArray[currentEntityIndex]) {
          tempArray[currentEntityIndex] = {
            ...row,
            [`${[fieldName]}RowSpan`]: rowSpan,
            [`${[fieldName]}RowSpanIndex`]: rowSpanIndex,
            [`previous_${[fieldName]}`]: row[`previous_${[fieldName]}`] ?? row[fieldName],
          }
        } else {
          tempArray[currentEntityIndex] = {
            ...tempArray[currentEntityIndex],
            [`${[fieldName]}RowSpan`]: rowSpan,
            [`${[fieldName]}RowSpanIndex`]: rowSpanIndex,
            [`previous_${[fieldName]}`]: row[`previous_${[fieldName]}`] ?? row[fieldName],
          }
        }

        newSummaryData[row.entity_id] = {
          ...newSummaryData[row.entity_id],
          data: tempArray,
        }
        tempSummaryData = newSummaryData
      })
    })
    return {tempSummaryData, existingObjIndex}
  }

  /**
   * Handle POA save
   * @type {UseMutationResult<DefaultSelectType, unknown, void, unknown>}
   */
  const handleOnSave = useMutation(
    () =>
      savePOA({
        requestId,
        country,
        segment,
        entity,
        currentOrder,
        generalDetails,
        requestDetails: serverPaginationResult.rowData,
      }),
    {
      onSuccess: (result, variables) => {
        setSnackBar({
          open: true,
          type: 'success',
          message: result?.status,
        })

        if (result?.poa_request_id) {
          navigate(`/Poa/edit/${country}/${result?.poa_request_id}`)
        }
      },
      onError: (err, variables, context) => {
        let message = null
        if (err?.data?.status) {
          message = err?.data?.status
        }
        setSnackBar((prevState) => ({
          ...prevState,
          open: true,
          message: message ?? prevState.message,
        }))
      },
      onSettled: () => {
        setIsCallingApi({
          loading: false,
          type: 'settled',
        })
        queryClient.invalidateQueries(`POA-${entity}`)
      },
    }
  )

  /**
   * Handle POA submission
   * @type {UseMutationResult<DefaultSelectType, unknown, void, unknown>}
   */
  const handleOnSubmit = useMutation(
    () =>
      submitPOA({
        requestId,
        country,
        segment,
        entity,
        currentOrder,
        generalDetails,
        requestDetails: serverPaginationResult.rowData,
      }),
    {
      onSuccess: (result, variables) => {
        setSnackBar({
          open: true,
          type: 'success',
          message: result?.status,
        })
        setIsCallingApi({
          loading: false,
          type: 'success',
        })

        if (!requestId) {
          navigate(`/Poa/edit/${country}/${segment}/${entity}/${result?.poa_request_id}`)
        }
      },
      onError: (err, variables, context) => {
        setSnackBar((prevState) => ({...prevState, open: true}))
      },
      onSettled: () => {
        setIsCallingApi({
          loading: false,
          type: 'settled',
        })
        queryClient.invalidateQueries(`POA-${entity}`)
      },
    }
  )

  /**
   * Handle POA withdraw
   * @type {UseMutationResult<DefaultSelectType, unknown, void, unknown>}
   */
  const handleWithdrawTicket = useMutation(
    () =>
      withdrawPOA(
        {
          requestId,
          country,
          segment,
          entity,
          currentOrder,
          generalDetails,
          requestDetails: serverPaginationResult.rowData,
        },
        actionDialog.value
      ),
    {
      onSuccess: (result, variables) => {
        setSnackBar({
          open: true,
          type: 'success',
          message: result?.status,
        })
      },
      onError: (err, variables, context) => {
        setSnackBar((prevState) => ({...prevState, open: true}))
      },
      onSettled: () => {
        setIsCallingApi({
          loading: false,
          type: 'settled',
        })
        setActionDialog((prevState) => ({
          ...prevState,
          type: null,
          value: null,
          open: false,
          isDisabled: false,
          isLoading: false,
        }))
        queryClient.invalidateQueries(`POA-${entity}`)
        queryClient.invalidateQueries(`poa-request-${requestId}-comments`)
      },
    }
  )

  /**
   * Handle POA rejection
   * @type {UseMutationResult<DefaultSelectType, unknown, void, unknown>}
   */
  const handleOnReject = useMutation(
    () =>
      rejectPOA(
        {
          requestId,
          country,
          segment,
          entity,
          currentOrder,
          generalDetails,
          requestDetails: serverPaginationResult.rowData,
        },
        actionDialog.value
      ),
    {
      onSuccess: (result, variables) => {
        setSnackBar({
          open: true,
          type: 'success',
          message: result?.status,
        })
      },
      onError: (err, variables, context) => {
        setSnackBar((prevState) => ({...prevState, open: true}))
      },
      onSettled: () => {
        setIsCallingApi({
          loading: false,
          type: 'settled',
        })
        setActionDialog((prevState) => ({
          ...prevState,
          type: null,
          value: null,
          open: false,
          isDisabled: false,
          isLoading: false,
        }))
        queryClient.invalidateQueries(`POA-${entity}`)
        queryClient.invalidateQueries(`poa-request-${requestId}-comments`)
      },
    }
  )

  /**
   * To add new comment
   * @type {UseMutationResult<*, unknown, string, {previousComments: unknown}>}
   */
  const addNewCommentToRequest = useMutation(
    (comment) => saveComments(comment, {requestId, ticketStatus: requestStatus}),
    {
      onMutate: async (commentField: string) => {
        setCommentField(undefined)
        await queryClient.cancelQueries(`poa-request-${requestId}-comments`)

        const previousComments = queryClient.getQueryData(
          `poa-request-${requestId}-comments`
        )

        if (previousComments) {
          queryClient.setQueryData(`poa-request-${requestId}-comments`, [
            {
              full_name: localStorage.getItem('username'),
              comment_date_format: moment(new Date()).format('YYYY-MM-DD HH:mm'),
              comments: commentField,
            },
            ...previousComments,
          ])
        }

        return {previousComments}
      },
      onSuccess: (result) => {
        setSnackBar({open: true, type: 'success', message: result.status})
      },
      onError: (err, variables, context) => {
        setSnackBar((prevState) => ({...prevState, open: true}))

        if (context?.previousComments) {
          queryClient.setQueryData(
            `poa-request-${requestId}-comments`,
            context.previousComments
          )
        }
      },
      onSettled: () => {
        setIsCallingApi({
          loading: false,
          type: null,
        })
        queryClient.invalidateQueries(`poa-request-${requestId}-comments`)
      },
    }
  )

  /**
   * To toggle table menu open
   * @param event
   * @param entityId
   * @param dataIndex
   */
  const handleTableMenuClick = (event, entityId, dataIndex) => {
    setToMutateEntityRow({
      entityId,
      dataIndex,
    })
    setMenuObject({
      type: dataIndex !== undefined ? 'table-menu' : 'entity-menu',
      event: event.currentTarget,
    })
  }

  /**
   * To toggle table menu close
   */
  const handleTableMenuClose = () => {
    setMenuObject(null)
    setToMutateEntityRow(null)
    setSelectedCell([])
    setToEditCell(null)
  }

  /**
   * To merge cells
   */
  const mergeCells = () => {
    if (selectedCell.length <= 1) {
      return
    }

    let validated = true
    let smallestIndex = null
    let toBeMutateFieldName = null
    let mergedEntityCell = null
    let isSequential = []

    // // we will loop every selected cell to validate it and only break the loop upon failed validation
    selectedCell.every((value, index) => {
      const splitRow = value.split('-')

      // entity - index - fieldname - rowspan
      const entityId = splitRow[0]
      const dataIndex = parseInt(splitRow[1])
      const fieldName = splitRow[2]
      const rowSpan = parseInt(splitRow[3])

      let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]

      // we instantiate the first selected cell selected entity & field name
      if (!toBeMutateFieldName) {
        toBeMutateFieldName = fieldName
        mergedEntityCell = modifiedRowData[dataIndex].entity_id
      }

      //cant merge across diff field
      if (toBeMutateFieldName !== fieldName) {
        setSnackBar({
          open: true,
          type: 'error',
          message: 'Unable to merge across different field',
        })
        validated = false
        return false
      }

      //cant merge across entity
      if (mergedEntityCell !== modifiedRowData[dataIndex].entity_id) {
        setSnackBar({
          open: true,
          type: 'error',
          message: 'Cannot merge cell across entity',
        })
        validated = false
        return false
      }

      if (smallestIndex === null || smallestIndex > dataIndex) {
        smallestIndex = dataIndex
      }

      isSequential.push({dataIndex, rowSpan})
      if (selectedCell.length === index + 1) {
        // can’t merge value if sequence is wrong
        isSequential
          .sort(function (a, b) {
            return a.dataIndex - b.dataIndex
          })
          .every((value, valueIndex) => {
            if (isSequential.length === valueIndex + 1) {
              return false
            }

            if (
              value.dataIndex + value.rowSpan !==
              isSequential[valueIndex + 1].dataIndex
            ) {
              setSnackBar({
                open: true,
                type: 'error',
                message: 'Unable to merge across cell',
              })
              validated = false

              return false
            }
            return true
          })
      }
      return true
    })

    if (!validated) {
      return
    }

    let modifiedRowData = [...serverPaginationResult.rowData[mergedEntityCell].data]
    let firstValue = modifiedRowData[smallestIndex][toBeMutateFieldName]
    let categoryId = null
    if (toBeMutateFieldName === 'category') {
      categoryId = modifiedRowData[smallestIndex].poa_category_id
    }
    let toMutate = true

    for (const sequence of isSequential) {
      const {dataIndex} = sequence
      if (modifiedRowData[dataIndex][toBeMutateFieldName] !== null) {
        if (
          firstValue &&
          firstValue !== modifiedRowData[dataIndex][toBeMutateFieldName]
        ) {
          toMutate = false
          setOpenAlertDialog({
            toBeMutateFieldName,
            mergedEntityCell,
            isSequential,
            firstValue,
            categoryId: toBeMutateFieldName === 'category' ? categoryId : null,
            type: 'merge-cell',
            open: true,
          })
          return
        }

        firstValue = modifiedRowData[dataIndex][toBeMutateFieldName]
        if (toBeMutateFieldName === 'category') {
          categoryId = modifiedRowData[dataIndex].poa_category_id
        }
      }
    }

    //we shall call mutate merge cell
    if (toMutate) {
      toMutateMergeCell({
        toBeMutateFieldName,
        mergedEntityCell,
        isSequential,
        firstValue,
        categoryId,
      })
    }
  }

  /**
   * To modify the cell row span
   * @param toBeMutateFieldName
   * @param mergedEntityCell
   * @param isSequential
   * @param firstValue
   */
  const toMutateMergeCell = ({
    toBeMutateFieldName,
    mergedEntityCell,
    isSequential,
    firstValue,
    categoryId = null,
  }) => {
    const rowSpanField = `${toBeMutateFieldName}RowSpan`
    const rowSpanFieldIndex = `${toBeMutateFieldName}RowSpanIndex`
    let modifiedRowData = [...serverPaginationResult.rowData[mergedEntityCell].data]

    for (let i = 0; i < isSequential.length; i++) {
      // because the cell by default are already merge together...
      // we jus check if their value is the same for the current dataIndex and previous dataIndex
      const dataIndex = isSequential[i].dataIndex
      const rowSpan = isSequential[i].rowSpan
      let newDataIndex = isSequential[i].dataIndex

      if (i !== 0) {
        // sub data
        const currentCellValue = formatCellValue(
          modifiedRowData[dataIndex][`previous_${toBeMutateFieldName}`]
        )
        const prevCellValue = formatCellValue(
          modifiedRowData[isSequential[i - 1].dataIndex][
            `previous_${toBeMutateFieldName}`
          ]
        )

        if (
          modifiedRowData[dataIndex].request_type ===
            modifiedRowData[isSequential[i - 1].dataIndex].request_type &&
          (currentCellValue.localeCompare(prevCellValue) === 0 ||
            modifiedRowData[dataIndex].request_type === 'add')
        ) {
          //same previous data can merge
          modifiedRowData[dataIndex][rowSpanField] = 0
          modifiedRowData[dataIndex][rowSpanFieldIndex] =
            modifiedRowData[isSequential[i - 1].dataIndex][rowSpanFieldIndex]
          modifiedRowData[dataIndex][toBeMutateFieldName] = firstValue
          if (categoryId) {
            modifiedRowData[dataIndex].poa_category_id = categoryId
          }
          // we add the rowSpan to the index rowspan
          modifiedRowData[
            modifiedRowData[isSequential[i - 1].dataIndex][rowSpanFieldIndex]
          ][rowSpanField]++
          // if its the same we will point it back for the subdata.
          newDataIndex = modifiedRowData[isSequential[i - 1].dataIndex][rowSpanFieldIndex]
        } else {
          // diff previous data cannot merge so we jus copy value over
          modifiedRowData[dataIndex][rowSpanField] = 1
          modifiedRowData[dataIndex][rowSpanFieldIndex] = dataIndex
          modifiedRowData[dataIndex][toBeMutateFieldName] = firstValue
          if (categoryId) {
            modifiedRowData[dataIndex].poa_category_id = categoryId
          }
        }
      } else {
        // first data
        modifiedRowData[dataIndex][rowSpanField] = 1
        modifiedRowData[dataIndex][rowSpanFieldIndex] = dataIndex
        modifiedRowData[dataIndex][toBeMutateFieldName] = firstValue

        if (categoryId) {
          modifiedRowData[dataIndex].poa_category_id = categoryId
        }
      }

      // this is for the sub data index row
      for (
        let i = dataIndex + 1;
        i < (dataIndex === 0 ? rowSpan : rowSpan + dataIndex);
        i++
      ) {
        modifiedRowData[i][rowSpanField] = 0
        modifiedRowData[i][rowSpanFieldIndex] = newDataIndex
        modifiedRowData[i][toBeMutateFieldName] = firstValue
        if (categoryId) {
          modifiedRowData[i].poa_category_id = categoryId
        }

        // add to the previous row
        modifiedRowData[newDataIndex][rowSpanField]++
      }
    }
    setServerPaginationResult((prevState) => ({
      ...prevState,
      rowData: {
        ...prevState.rowData,
        [mergedEntityCell]: {
          ...prevState.rowData[mergedEntityCell],
          data: modifiedRowData,
        },
      },
    }))

    setSelectedCell([])
    setOpenAlertDialog({open: false})
  }

  /**
   * To unmerge merged cell
   */
  const splitCells = () => {
    selectedCell.forEach((value) => {
      const splitRow = value.split('-')

      // entity - index - fieldname - rowspan
      const entityId = splitRow[0]
      const dataIndex = parseInt(splitRow[1])
      const fieldName = splitRow[2]
      const rowSpan = parseInt(splitRow[3])

      let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]

      for (
        let i = dataIndex;
        i < (dataIndex === 0 ? rowSpan : rowSpan + dataIndex);
        i++
      ) {
        modifiedRowData[i][`${fieldName}RowSpan`] = 1
        modifiedRowData[i][`${fieldName}RowSpanIndex`] = i
      }

      setServerPaginationResult((prevState) => ({
        ...prevState,
        rowData: {
          ...prevState.rowData,
          [entityId]: {
            ...prevState.rowData[entityId],
            data: modifiedRowData,
          },
        },
      }))
    })
    setSelectedCell([])
  }

  /**
   * To add new row to table
   */
  const addNewRow = () => {
    const entityId = toMutateEntityRow.entityId

    const entityName = serverPaginationResult.rowData[entityId].name
    let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]

    let data = handleAddRow({
      modifiedRowData,
      value: {
        country: country,
        entityId: entityId,
        entityName: entityName,
      },
    })

    modifiedRowData.push(data)

    setServerPaginationResult((prevState) => ({
      ...prevState,
      rowData: {
        ...prevState.rowData,
        [entityId]: {
          ...prevState.rowData[entityId],
          data: modifiedRowData,
        },
      },
    }))

    handleTableMenuClose()
  }

  const handleAddRow = ({modifiedRowData, value}) => {
    return {
      request_type: 'add',
      approve_date: null,
      approve_date_format: null,
      country_id: value?.country ?? null, // Using optional chaining and nullish coalescing
      entity_id: value?.entityId ?? null, // Same as above
      entity_code: value?.entityCode ?? null, // Same as above
      entity_name: value?.entityName ?? null, // Same as above
      category: value?.category ?? null, // default to null if not provided
      categoryRowSpan: 1,
      categoryRowSpanIndex: modifiedRowData?.length ?? 1,
      agent: value?.agent ?? null, // default to null if not provided
      agentRowSpan: 1,
      agentRowSpanIndex: modifiedRowData?.length ?? 1,
      forms_to_be_signed: value?.forms_to_be_signed ?? null, // default to null if not provided
      forms_to_be_signedRowSpan: 1,
      forms_to_be_signedRowSpanIndex: modifiedRowData?.length ?? 1,
      risk_level: value?.risk_level ?? null, // default to null if not provided
      risk_levelRowSpan: 1,
      risk_levelRowSpanIndex: modifiedRowData?.length ?? 1,
      internal_approval_requirement: value?.internal_approval_requirement ?? null, // default to null if not provided
      internal_approval_requirementRowSpan: 1,
      internal_approval_requirementRowSpanIndex: modifiedRowData?.length ?? 1,
      internal_approval: value?.internal_approval ?? null, // default to null if not provided
      internal_approvalRowSpan: 1,
      internal_approvalRowSpanIndex: modifiedRowData?.length ?? 1,
      principal: value?.principal ?? null, // default to null if not provided
      principalRowSpan: 1,
      principalRowSpanIndex: modifiedRowData?.length ?? 1,
      remarks: value?.remarks ?? null, // default to null if not provided
      remarksRowSpan: 1,
      remarksRowSpanIndex: modifiedRowData?.length ?? 1,
      sub_category: value?.sub_category ?? null, // default to null if not provided
      sub_categoryRowSpan: 1,
      sub_categoryRowSpanIndex: modifiedRowData?.length ?? 1,
      segment_id: value?.segment_id ?? null, // default to null if not provided
      segment_idRowSpan: 1,
      segment_idRowSpanIndex: modifiedRowData?.length ?? 1,
      poa_id: null, // keep as null, can be updated based on additional logic
      poa_category_id: value?.poa_category_id ?? null, // default to null if not provided
      poa_request_detail_id: null,
      poa_request_id: null,
    }
  }
  /**
   * To delete row from table
   */
  const deleteRow = () => {
    // we get the entity ID of the row we re gonna delete
    const entityId = toMutateEntityRow.entityId

    // the entity row data that we will be modifying
    let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]
    const rowDataIndex = toMutateEntityRow.dataIndex

    // if row is already deleted, we will ignore
    if (modifiedRowData[rowDataIndex] === 'delete') {
      handleTableMenuClose()
      return
    }

    modifiedRowData = handleDeleteRow(modifiedRowData, rowDataIndex)

    setServerPaginationResult((prevState) => ({
      ...prevState,
      rowData: {
        ...prevState.rowData,
        [entityId]: {
          ...prevState.rowData[entityId],
          data: modifiedRowData,
        },
      },
    }))
    handleTableMenuClose()
  }

  const handleDeleteRow = (modifiedRowData, rowDataIndex) => {
    // looping all the field to mutate all their rowspan & rowspan index
    toMergeField.forEach((value) => {
      //prefix the rowspan field name
      const fieldRowSpan = `${value}RowSpan`
      //prefix the rowspan index field name
      const fieldRowSpanIndex = `${value}RowSpanIndex`

      // if rowSpan === 1 && request_type !== add we can jus ignore it
      // because only for request_type === 'add' we need to splice it after so all the index will be shifted up
      if (
        modifiedRowData[rowDataIndex][fieldRowSpan] === 1 &&
        modifiedRowData[rowDataIndex].request_type !== 'add'
      ) {
        return
      }

      // below consists the code to mutate the follow field rowSpan & rowIndex
      // ---------START---------
      // we get the field rowSpanIndex first
      const rowSpanIndex = modifiedRowData[rowDataIndex][fieldRowSpanIndex]

      // we get the field rowSpan value next - this is needed to loop the relevant row
      const rowSpans = modifiedRowData[rowSpanIndex][fieldRowSpan]

      // we need to split the row span if we hit the deleted rowspan index
      let splitRowSpanIndex = rowSpanIndex

      // max row to loop to mutate
      const maxRowToLoop = rowSpans + rowSpanIndex

      for (let i = rowSpanIndex; i < maxRowToLoop; i++) {
        // if we hit the row data index to delete
        // theres 2 scenario
        // 1. request type === 'add'
        //    subsequent row rowSpanIndex needs to -1 as the current rowSpanIndex will be spliced.
        //    so the row will be shift up
        // 2. request type !== 'add'
        //    if rowSpanIndex !== rowDataIndex
        //      we can safely change the rowSpan to 1
        //      we can point the rowDataIndex back to itself
        //    if rowSpanIndex === rowDataIndex
        //      we need to push it to the next record to be the rowDataIndex
        if (i === rowDataIndex) {
          if (modifiedRowData[i].request_type === 'add') {
            if (i !== rowSpanIndex) {
              // we need to deduct the rowspan from the main index
              modifiedRowData[rowSpanIndex][fieldRowSpan]--
            }

            if (i === rowSpanIndex && modifiedRowData[i][fieldRowSpan] > 1) {
              // we need to pass the fieldRowSpan to the next row
              // the rowSpan index will be the same because it will be splice
              modifiedRowData[i + 1][fieldRowSpan] = modifiedRowData[i][fieldRowSpan] - 1
            }

            if (maxRowToLoop < modifiedRowData.length) {
              for (let x = maxRowToLoop; x < modifiedRowData.length; x++) {
                modifiedRowData[x][fieldRowSpanIndex] =
                  modifiedRowData[x][fieldRowSpanIndex] - 1
              }
            }
          } else if (rowDataIndex !== rowSpanIndex) {
            modifiedRowData[rowSpanIndex][fieldRowSpan]--

            modifiedRowData[i][fieldRowSpan] = 1
            modifiedRowData[i][fieldRowSpanIndex] = rowDataIndex

            //we set the new index to the next one..
            splitRowSpanIndex = i + 1
          }
        }

        if (i > rowDataIndex && modifiedRowData[rowDataIndex].request_type !== 'add') {
          // if record is not add we shall not split it!
          modifiedRowData[rowSpanIndex][fieldRowSpan]--

          if (splitRowSpanIndex !== rowSpanIndex) {
            modifiedRowData[splitRowSpanIndex][fieldRowSpan]++
            modifiedRowData[i][fieldRowSpanIndex] = splitRowSpanIndex
          } else {
            splitRowSpanIndex = i
            modifiedRowData[i][fieldRowSpan]++
            modifiedRowData[i][fieldRowSpanIndex] = i
          }
        }
      }
    })

    // lets remove it if type was 'add'
    if (modifiedRowData[rowDataIndex].request_type === 'add') {
      // because this is a new row so we can jus delete and pretend nothing happened.
      modifiedRowData.splice(rowDataIndex, 1)
    } else {
      modifiedRowData[rowDataIndex].request_type = 'delete'
    }

    return modifiedRowData
  }
  /**
   * Undo row deletion from table
   */
  const undoDeleteRow = () => {
    const entityId = toMutateEntityRow.entityId

    const dataIndex = toMutateEntityRow.dataIndex

    let modifiedRowData = [...serverPaginationResult.rowData[entityId].data]
    if (
      modifiedRowData[dataIndex].request_type &&
      modifiedRowData[dataIndex].request_type === 'add'
    ) {
      handleTableMenuClose()
      return
    }

    modifiedRowData[dataIndex].request_type = 'edit'

    setServerPaginationResult((prevState) => ({
      ...prevState,
      rowData: {
        ...prevState.rowData,
        [entityId]: {
          ...prevState.rowData[entityId],
          data: modifiedRowData,
        },
      },
    }))
    handleTableMenuClose()
  }

  /**
   * To upload file
   * @type {UseMutationResult<*, unknown, void, unknown>}
   */
  const handleFileUpload = useMutation(
    (file) =>
      uploadRequestAttachment({
        poaRequestId: requestId,
        attachmentType: 'poa',
        attachment: file,
        user: user.email,
      }),
    {
      onSuccess: (result) => {
        setSnackBar((prevState) => ({
          ...prevState,
          open: true,
          type: 'success',
          message: 'Attachment uploaded successfully!',
        }))
      },
      onError: (err, variables, context) => {
        setSnackBar((prevState) => ({...prevState, open: true}))
      },
      onSettled: () => {
        queryClient.invalidateQueries(`poa-request-${requestId}-attachments`)
        setIsFileUploading(false)
        setIsCallingApi({
          loading: false,
          type: null,
        })
      },
    }
  )

  /**
   * To delete file
   * @type {UseMutationResult<*, unknown, void, unknown>}
   */
  const handleDeleteFile = useMutation(({id, index}) => deleteAttachment({id}), {
    onSuccess: () => {
      setSnackBar({
        open: true,
        type: 'success',
        message: 'Attachment deleted successfully',
      })
    },
    onError: (err, variables, context) => {
      setSnackBar((prevState) => ({...prevState, open: true}))
    },
    onSettled: () => {
      setIsCallingApi({
        loading: false,
        type: null,
      })
      queryClient.invalidateQueries(`poa-request-${requestId}-attachments`)
    },
  })

  /**
   * To download file
   * @type {UseMutationResult<*, unknown, void, unknown>}
   */
  const handleDownloadAttachment = useMutation(({id}) => downloadAttachment({id}), {
    onError: (err) => {
      console.log(err)
      setSnackBar({
        open: true,
      })
    },
    onSettled: () => {
      setIsCallingApi({
        loading: false,
        type: null,
      })
    },
  })

  /**
   * To handle file preview
   * @type {UseMutationResult<unknown, unknown, void, unknown>}
   */
  const handlePreviewFile = useMutation(({id, name}) => previewAttachment({id}), {
    onSuccess: (result, {name}) => {
      setFilePreviewDialog({
        value: result,
        name: name,
        open: true,
      })
    },
  })

  /**
   * To validate call value before submitting
   */
  const validateCell = () => {
    let isGeneralDetailsValid = true
    for (const fieldName of ['changeSummary']) {
      if (!generalDetails[fieldName]) {
        isGeneralDetailsValid = false
        setGeneralDetails((prevState) => ({
          ...prevState,
          [`error_${fieldName}`]: 'This field is required!',
        }))
      }
    }

    if (!isGeneralDetailsValid) {
      setSnackBar({
        open: true,
        type: 'error',
        message: `Incomplete form! Please fill up all the required/ invalid fields`,
      })

      setIsCallingApi({
        loading: false,
        type: null,
      })
      return
    }

    if (serverPaginationResult.rowData.length === 0) {
      setSnackBar({
        open: true,
        type: 'error',
        message: `Unable to submit empty request details!`,
      })

      setIsCallingApi({
        loading: false,
        type: null,
      })
      return
    }

    let isRequestModified = false
    // 1. to loop entity
    for (const [key, value] of Object.entries(serverPaginationResult.rowData)) {
      // 2. to loop data
      let cellIndex = 0
      for (const details of value.data) {
        cellIndex++
        // 3. to check for category
        if (!details.poa_category_id && details.type !== 'delete') {
          setSnackBar({
            open: true,
            type: 'error',
            message: `Missing Category value at Row ${cellIndex}!`,
          })
          setIsCallingApi({
            loading: false,
            type: null,
          })
          return
        }

        if (!isRequestModified) {
          for (const fieldName of toMergeField) {
            // lets check for
            // 1. previous & current value
            // 2. request type
            const currentCellValue = formatCellValue(details[fieldName])
            const prevCellValue = formatCellValue(details[`previous_${fieldName}`])
            if (
              (typeof prevCellValue === 'number'
                ? prevCellValue !== currentCellValue
                : prevCellValue.localeCompare(currentCellValue) !== 0) ||
              ['add', 'delete'].includes(details.request_type)
            ) {
              isRequestModified = true
              break
            }
          }
        }
      }
    }

    setSelectedCell([])
    if (requestId && !isRequestModified) {
      setSnackBar({
        open: true,
        type: 'error',
        message: `Unable to submit form, no changes detected!`,
      })

      setIsCallingApi({
        loading: false,
        type: null,
      })
      return
    }

    requestId ? handleOnSubmit.mutate() : handleOnSave.mutate()
  }

  /**
   * To handle the error log
   */
  const exportPOAData = () => {
    const poaRows = Object.values(serverPaginationResult.rowData)
      .sort((a, b) => a.orderIndex - b.orderIndex)
      .map((item) => item.data)
      .flat()

    // Prepare POA data
    const poaData = poaRows.map((value) => [
      value.request_type,
      value.poa_id,
      value.country_id,
      value.segment_id,
      value.entity_code ?? value.entity_name,
      value.category,
      value.sub_category,
      value.forms_to_be_signed,
      value.risk_level,
      value.internal_approval_requirement,
      value.internal_approval,
      value.principal,
      value.agent,
      value.remarks,
    ])

    // Create a new workbook and worksheet
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(`${country}_poa_request`)

    ws.columns = [
      {header: 'Action', key: 'action', width: 10},
      {header: 'Poa Id', key: 'poaId', width: 10},
      {header: 'Country', key: 'country', width: 10},
      {header: 'Segment', key: 'segment', width: 10},
      {header: 'Entity', key: 'entity', width: 15},
      {header: 'Category', key: 'category', width: 20},
      {header: 'Sub Category', key: 'subCategory', width: 25},
      {header: 'Forms to be Signed', key: 'formsToBeSigned', width: 25},
      {header: 'Risk Level', key: 'riskLevel', width: 30},
      {
        header: 'Internal Approval Requirement',
        key: 'internalApprovalRequirement',
        width: 30,
      },
      {header: 'Internal Approval', key: 'internalApproval', width: 30},
      {header: 'Principal', key: 'principal', width: 30},
      {header: 'Agent', key: 'agent', width: 30},
      {header: 'Remarks', key: 'remarks', width: 30},
    ]

    // Add source page to set dropdown values
    const source_ws = wb.addWorksheet(`source`)
    const actions = ['add', 'edit', 'delete']
    const categories = [
      'Bank - Transactions',
      'Bank - Admin',
      'Invoice- Admin',
      'Tax',
      'Reports',
      'Accounting',
      'Audit',
      'Reporting',
      'Business/partnership',
      'Dividends',
    ]
    source_ws.addRow(actions)
    source_ws.addRow(categories)
    source_ws.state = 'hidden'

    // Set data validation/dropdown values to 'Action' (Column A) and 'Category' (column F)
    const actionValues = {
      type: 'list',
      allowBlank: true,
      formulae: ['source!$A$1:$C$1'],
    }
    const categoryValues = {
      type: 'list',
      allowBlank: true,
      formulae: ['source!$B$2:$H$2'],
    }

    ws.eachRow(function (row, rowNumber) {
      row.eachCell((cell, colNumber) => {
        if (colNumber == 1) {
          for (let i = 2; i <= 30; i++) {
            const cellAddress = `A${i}`
            ws.getCell(cellAddress).dataValidation = actionValues
          }
        }
        if (colNumber == 6) {
          for (let i = 2; i <= 30; i++) {
            const cellAddress = `F${i}`
            ws.getCell(cellAddress).dataValidation = categoryValues
          }
        }
      })
    })

    // Add data with rich text formatting
    poaData.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        const {plainText, richText} = getStyledCellValue(cell)

        // Set rich text to the cell (if applicable)
        const cellRef = ws.getCell(rowIndex + 2, colIndex + 1) // rowIndex + 2 for row number, colIndex + 1 for column number
        if (richText.length > 0) {
          cellRef.value = {richText}
        } else {
          cellRef.value = plainText // For normal text without rich text
        }
      })
    })

    ws.eachRow(function (row, rowNumber) {
      row.eachCell((cell, colNumber) => {
        if (rowNumber == 1) {
          // First set the background of header row
          if ([2, 3, 4, 5].includes(colNumber)) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {argb: 'D3D3D3'},
            }
          } else {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {argb: 'FFFF00'},
            }
          }
        }
        // Set text wrapping for each cell
        cell.alignment = {
          wrapText: true, // Enable text wrapping
        }
      })
      //Commit the changed row to the stream
      row.commit()
    })

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const fileExtension = '.xlsx'
    // save workbook to disk
    wb.xlsx
      .writeBuffer('sample.xlsx')
      .then((data) => {
        const blob = new Blob([data], {type: fileType})

        saveAs(
          blob,
          `${moment().format(dateTimeFormatTableForFile)}_${country}_poa_data` +
            fileExtension
        )
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  /**
   * To render submit/ approve/ verify button based on current order
   * @return {JSX.Element|string}
   */
  const renderActionButton = () => {
    if (!editable) {
      return
    }

    // currentOrder = undefined || 0 means its draft user is able to save/ submit
    switch (currentOrder) {
      case 1: // verify
        return generalDetails.requestedBy !== user.email ? (
          <>
            <Button
              disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
              loading={isCallingApi.type === 'verify'}
              label={'Verify'}
              onClick={() => {
                setIsCallingApi({
                  loading: true,
                  type: 'verify',
                })
                handleOnSubmit.mutate()
              }}
            />
            <Button
              label={'Reject'}
              disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
              loading={isCallingApi.type === 'reject'}
              type={'danger'}
              onClick={() => {
                setIsCallingApi({
                  loading: true,
                  type: 'reject',
                })
                setActionDialog((prevState) => ({
                  ...prevState,
                  type: 'Reject',
                  value: null,
                  open: true,
                }))
              }}
            />
          </>
        ) : (
          <></>
        )
      case 2: // approve 1
      case 3: // approve 2
        return generalDetails.requestedBy !== user.email ? (
          <>
            <Button
              disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
              loading={isCallingApi.type === 'approve'}
              label={`Approve`}
              onClick={() => {
                setIsCallingApi({
                  loading: true,
                  type: 'approve',
                })
                handleOnSubmit.mutate()
              }}
            />
            <Button
              label={'Reject'}
              disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
              loading={isCallingApi.type === 'reject'}
              type={'danger'}
              onClick={() => {
                setIsCallingApi({
                  loading: true,
                  type: 'reject',
                })
                setActionDialog((prevState) => ({
                  ...prevState,
                  type: 'Reject',
                  value: null,
                  open: true,
                }))
              }}
            />
          </>
        ) : (
          <></>
        )
      case 4: // apply changes
      case 99: // completed
      case 100: // rejected
        return ''
      default:
        // undefined & 0
        return (
          <>
            {requestId && (
              <Button
                label={'Save'}
                disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
                loading={isCallingApi.type === 'save'}
                onClick={() => {
                  setIsCallingApi({
                    loading: true,
                    type: 'save',
                  })
                  handleOnSave.mutate()
                }}
              />
            )}

            <Button
              disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
              loading={isCallingApi.type === 'submit'}
              label={`${requestId ? 'Submit' : 'Create'}`}
              onClick={() => {
                setIsCallingApi({
                  loading: true,
                  type: 'submit',
                })
                requestId ? validateCell() : handleOnSave.mutate()
              }}
            />
          </>
        )
    }
  }

  /**
   * To render comments
   * @return {string|*}
   */
  const renderComments = () => {
    if (!requestId) {
      return
    }

    if (comments.length === 0) {
      return 'No comment'
    }

    return comments.map(({full_name, comment_date_format, comments, status}, key) => {
      const htmlComment = parse(comments)
      return (
        <>
          <Stack direction={'column'} spacing={0} key={key}>
            <Stack direction={'row'} spacing={1} alignItems={'start'}>
              <StringAvatar label={full_name} style={{width: 35, height: 35}} />
              <Stack direction={'column'}>
                <Typography align={'left'} sx={{fontWeight: '600'}} variant={'body2'}>
                  {full_name}
                </Typography>
                <Stack direction={'row'}>
                  <Typography align={'left'} variant={'caption'}>
                    {comment_date_format}{' '}
                  </Typography>

                  {status && (
                    <Typography align={'left'} variant={'caption'} color={'secondary'}>
                      · {status}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
            <Typography
              className={'comment-wrap'}
              align={'left'}
              variant={'body2'}
              gutterBottom
            >
              {htmlComment}
            </Typography>
          </Stack>
        </>
      )
    })
  }

  /**
   * To render menu item
   * @param type
   * @return {JSX.Element}
   */
  const renderMenu = (type) => {
    switch (type) {
      case 'entity-menu':
        return (
          <MenuItem key={`entity-table-menu`} onClick={addNewRow}>
            Insert Row
          </MenuItem>
        )
      case 'table-menu':
        return [
          {onClick: addNewRow, title: 'Insert Row'},
          {onClick: deleteRow, title: 'Delete Row'},
          {onClick: undoDeleteRow, title: 'Undo Delete Row'},
        ].map(({onClick, title}, index) => {
          return (
            <MenuItem key={`${index}-table-menu`} onClick={onClick}>
              {title}
            </MenuItem>
          )
        })
      default:
        break
    }
  }

  if (
    isSummaryLoading ||
    isEntitiesLoading ||
    isCategoriesLoading ||
    isCommentsLoading ||
    isAttachmentsLoading
  ) {
    return <Loading open={true} />
  }

  return (
    <>
      <ImportExcel
        templateUrl={null}
        open={openImport.open}
        type={openImport.type}
        handleClose={() => {
          setOpenImport((prevState) => ({...prevState, open: false}))
        }}
        columns={poaImportColumn}
        handleExcelUpload={(data) => {
          // Make a copy of the server pagination data
          let rowData = {...serverPaginationResult.rowData}

          // Initialize mutated_data to store all changes
          data
            .filter(({Action}) => Action) // Only process data with an action
            .forEach((value) => {
              // Declare modifiedRowData once, outside of the switch statement
              let modifiedRowData
              let existingObj
              let newEntityObj
              // Process data based on the action
              switch (value['Action']) {
                case 'add':
                  const entityId = entitiesObj[value['Entity']]?.entity_id

                  if (entityId !== undefined) {
                    if (!rowData[entityId]) {
                      newEntityObj = {
                        [entityId]: {
                          data: [],
                          name: `${entitiesObj[value['Entity']]?.entity_name} (${
                            value['Entity']
                          })`,
                          request_type: 'add',
                        },
                      }
                      rowData = {...rowData, ...newEntityObj}
                    }

                    modifiedRowData = rowData[entityId].data
                    let newRowData = handleAddRow({
                      modifiedRowData,
                      value: {
                        country: value['Country'],
                        entityId: entityId,
                        entityCode: value['Entity'],
                        entityName: `${entitiesObj[value['Entity']]?.entity_name} (${
                          value['Entity']
                        })`,
                        category: value['Category'],
                        agent: value['Agent'],
                        forms_to_be_signed: value['Forms to be Signed'],
                        risk_level: value['Risk Level'],
                        internal_approval_requirement:
                          value['Internal Approval Requirement'],
                        internal_approval: value['Internal Approval'],
                        principal: value['Principal'],
                        remarks: value['Remarks'],
                        sub_category: value['Sub Category'],
                        segment_id: value['Segment'],
                        poa_category_id:
                          categoriesObj[value['Category']]?.poa_category_id,
                      },
                    })
                    modifiedRowData.push(newRowData) // Add the new row to the modified data
                  }
                  break

                case 'edit':
                  existingObj = serverPaginationResult.tempObjIndex[value['Poa Id']]

                  if (!existingObj) {
                    return // If no matching object, return early
                  }

                  modifiedRowData = rowData[existingObj.entity_id].data

                  // Update the row with new values
                  modifiedRowData[existingObj.index].request_type = 'edit'
                  modifiedRowData[existingObj.index].category = value['Category']
                  modifiedRowData[existingObj.index].agent = value['Agent']
                  modifiedRowData[existingObj.index].forms_to_be_signed =
                    value['Forms to be Signed']
                  modifiedRowData[existingObj.index].risk_level = value['Risk Level']
                  modifiedRowData[existingObj.index].internal_approval_requirement =
                    value['Internal Approval Requirement']
                  modifiedRowData[existingObj.index].internal_approval =
                    value['Internal Approval']
                  modifiedRowData[existingObj.index].principal = value['Principal']
                  modifiedRowData[existingObj.index].remarks = value['Remarks']
                  modifiedRowData[existingObj.index].sub_category = value['Sub Category']
                  modifiedRowData[existingObj.index].segment_id = value['Segment']
                  modifiedRowData[existingObj.index].poa_category_id =
                    categoriesObj[value['Category']]?.poa_category_id

                  // Update the data
                  rowData[existingObj.entity_id].data = modifiedRowData
                  break

                case 'delete':
                  existingObj = serverPaginationResult.tempObjIndex[value['Poa Id']]

                  if (!existingObj) {
                    return // If no matching object, return early
                  }

                  // Find the row and delete
                  modifiedRowData = rowData[existingObj.entity_id].data
                  modifiedRowData = handleDeleteRow(modifiedRowData, existingObj.index)

                  // Update the data
                  rowData[existingObj.entity_id].data = modifiedRowData
                  break

                default:
                  // Handle unknown action
                  console.log('Unknown action:', value['Action'])
                  break
              }
            })

          // Extract all data arrays from rowData
          const allData = Object.values(rowData)
            .map((item) => item.data)
            .flat()
          const {tempSummaryData, existingObjIndex} = handleToMergeField([], allData)
          // for pagination: cnt no. of distinct entity_id
          const distinctEntityCount = Object.keys(tempSummaryData).length

          setServerPaginationResult({
            rowData: tempSummaryData,
            tempObjIndex: existingObjIndex,
            totalPages: distinctEntityCount ?? 0,
            // distinctEntityCount < 10 ? 1 : Math.floor(distinctEntityCount / 10), //round page no. down to nearest int
            totalCount: summaryData?.summary?.length ?? summaryData.length,
            toNextPage: distinctEntityCount !== 0 ? 2 : 0, // set no. for initial state
            toPreviousPage: distinctEntityCount > 0 ? 1 : 0, // set no. for initial state
            currentPage: 1,
          })
        }}
        // isLoading={importExcel.isLoading}
        label={'Import POA'}
      />

      <FileDeleteDialog
        open={openDeleteFileDialog.open}
        onClose={() => setOpenDeleteFileDialog({open: false, index: null})}
        onSubmit={() => {
          handleDeleteFile.mutate({
            index: openDeleteFileDialog.index,
            id: attachments[openDeleteFileDialog.index].attachment_id,
          })
          setOpenDeleteFileDialog({open: false, index: null, func: null})
        }}
      />
      <FilePreviewDialog
        open={filePreviewDialog.open}
        value={{preview: filePreviewDialog.value, name: filePreviewDialog.name}}
        onClose={() =>
          setFilePreviewDialog({
            value: null,
            open: false,
          })
        }
      />

      {actionDialog.open && actionDialog.type === 'Withdraw' && (
        <Withdraw
          value={actionDialog.value}
          onChange={(value) =>
            setActionDialog((prevState) => ({
              ...prevState,
              value: value,
            }))
          }
          onSubmit={() => {
            setActionDialog((prevState) => ({
              ...prevState,
              isDisabled: true,
              isLoading: true,
            }))
            if (!actionDialog.value) {
              setSnackBar({
                open: true,
                type: 'error',
                message: `Missing reason to withdraw`,
              })

              setActionDialog((prevState) => ({
                ...prevState,
                isDisabled: false,
                isLoading: false,
              }))
              return
            }

            handleWithdrawTicket.mutate()
          }}
          onClose={() => {
            setIsCallingApi({
              loading: false,
              type: null,
            })
            setActionDialog((prevState) => ({
              type: null,
              value: null,
              open: false,
              isDisabled: false,
              isLoading: false,
            }))
          }}
          isDisabled={actionDialog.isDisabled}
          isLoading={actionDialog.isLoading}
        />
      )}

      {actionDialog.open && actionDialog.type === 'Reject' && (
        <Reject
          value={actionDialog.value}
          onChange={setActionDialog}
          onSubmit={() => {
            setActionDialog((prevState) => ({
              ...prevState,
              isDisabled: true,
              isLoading: true,
            }))
            if (!actionDialog.value) {
              setSnackBar({
                open: true,
                type: 'error',
                message: `Missing reason to reject`,
              })

              setActionDialog((prevState) => ({
                ...prevState,
                isDisabled: false,
                isLoading: false,
              }))
              return
            }

            handleOnReject.mutate()
          }}
          onClose={() => {
            setIsCallingApi({
              loading: false,
              type: null,
            })
            setActionDialog((prevState) => ({
              type: null,
              value: null,
              open: false,
              isDisabled: false,
              isLoading: false,
            }))
          }}
          isDisabled={actionDialog.isDisabled}
          isLoading={actionDialog.isLoading}
        />
      )}

      {openAlertDialog.open && (
        <AlertDialog
          type={'warning'}
          disableBackdropClick
          title={'Confirmation'}
          content={
            openAlertDialog.type === 'merge-cell' &&
            `Merging cells only keeps the first value and discards other values.`
          }
          buttons={[
            {
              label: 'Cancel',
              onClick: () => {
                setOpenAlertDialog({open: false})
              },
              type: 'text',
            },
            {
              label: 'Proceed',
              onClick: () =>
                openAlertDialog.type === 'merge-cell' &&
                toMutateMergeCell({
                  toBeMutateFieldName: openAlertDialog.toBeMutateFieldName,
                  mergedEntityCell: openAlertDialog.mergedEntityCell,
                  isSequential: openAlertDialog.isSequential,
                  firstValue: openAlertDialog.firstValue,
                  categoryId: openAlertDialog.categoryId,
                }),
            },
          ]}
        />
      )}
      <Menu
        id="table-menu"
        anchorEl={menuObject?.event}
        keepMounted
        open={Boolean(menuObject)}
        onClose={handleTableMenuClose}
      >
        {renderMenu(menuObject?.type)}
      </Menu>

      <FileUpload
        formDetails={attachments}
        disabled={!(currentOrder === 0 && editable)}
        open={fullScreenDialogConst.open}
        isCallingApi={isCallingApi}
        setIsCallingApi={setIsCallingApi}
        handleClose={() => {
          setFullScreenDialogConst({open: false, type: null})
        }}
        columns={[
          {
            name: 'File Name',
            fieldName: 'attachment_filename',
          },
          {
            name: 'Upload By',
            fieldName: 'last_updated_by',
          },
          {
            name: 'Date',
            fieldName: 'creation_date_format',
          },
        ]}
        setIsFileUploading={setIsFileUploading}
        isFileUploading={isFileUploading}
        handleFileDownload={(index) => {
          const file = attachments[index]
          handleDownloadAttachment.mutate({
            id: file.attachment_id,
          })
        }}
        handleFileUpload={(file) => handleFileUpload.mutate(file)}
        handleFileDelete={(index) => {
          setOpenDeleteFileDialog({
            open: true,
            index: index,
          })
        }}
        handleFilePreview={(index) => {
          const file = attachments[index]
          handlePreviewFile.mutate({
            id: file.attachment_id,
            name: file.attachment_filename,
          })
        }}
        hideDeleteButton={currentOrder === 0 && generalDetails.requestedBy === user.email}
        hideDeleteButtonValue={
          currentOrder === 0 && generalDetails.requestedBy === user.email
            ? user.email
            : ''
        }
        hideDeleteButtonField={'created_by'}
      />
      <DetailedLayout
        mainContent={
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Stack
                direction={'row'}
                spacing={2}
                justifyContent={'space-between'}
                alignItems={'center'}
                sx={{pr: '17px'}}
              >
                <Stack direction={'row'} spacing={1}>
                  {![
                    STATUS_COMPLETED,
                    STATUS_WITHDRAWN,
                    STATUS_REJECTED,
                    STATUS_VERIFIED,
                    STATUS_PENDING_SECOND_APPROVED,
                  ].includes(requestStatus) &&
                    requestId &&
                    generalDetails.requestedBy === user.email && (
                      <Button
                        label={'Withdraw'}
                        disabled={isCallingApi.loading || isCallingApi.type === 'settled'}
                        loading={isCallingApi.type === 'withdraw'}
                        type={'danger'}
                        onClick={() => {
                          setIsCallingApi({
                            loading: true,
                            type: 'withdraw',
                          })
                          setActionDialog((prevState) => ({
                            ...prevState,
                            type: 'Withdraw',
                            value: null,
                            open: true,
                          }))
                        }}
                      />
                    )}
                  {renderActionButton()}
                </Stack>
                <Stack direction={'row'} spacing={1}>
                  {editable && currentOrder === 0 && (
                    <Stack direction={'row'} spacing={0}>
                      <IconButton
                        title={'Import'}
                        handleOnClick={(event) => {
                          setOpenImport((prevState) => ({
                            ...prevState,
                            open: true,
                          }))
                        }}
                      >
                        <FileUploadIcon fontSize={'small'} />
                      </IconButton>
                      <IconButton
                        title={'Export POA Template'}
                        handleOnClick={(event) => {
                          exportPOAData()
                        }}
                      >
                        <FileDownloadIcon fontSize={'small'} />
                      </IconButton>
                      <Divider
                        orientation="vertical"
                        variant="middle"
                        sx={{paddingLeft: '8px'}}
                        flexItem
                      />
                      <IconButton title="Merge Cell" handleOnClick={() => mergeCells()}>
                        <img
                          src={MergeIcon}
                          alt="Merge"
                          width={18}
                          height={18}
                          style={{margin: '3px'}}
                        />
                      </IconButton>
                      <IconButton title="Split Cell" handleOnClick={() => splitCells()}>
                        <img
                          src={SplitIcon}
                          alt="Merge"
                          width={18}
                          height={18}
                          style={{margin: '3px'}}
                        />
                      </IconButton>
                    </Stack>
                  )}
                </Stack>
              </Stack>
            </Grid>
            {currentOrder !== 99 && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{paddingTop: '15px'}}>
                  <Accordion
                    title={'General'}
                    expanded
                    onChange={(e, expanded) => setIsChangeSummaryExpanded(expanded)}
                  >
                    <Grid container direction={'row'} columnSpacing={8} rowSpacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <ServerSideAutocomplete
                          textFieldProps={{
                            error: generalDetails.error_approver,
                            helperText: generalDetails.error_approver,
                          }}
                          label={'Approver 2'}
                          placeholder={'Search by name or email'}
                          value={generalDetails.approver ?? {full_name: '', email: ''}}
                          handleOnChange={(value) => {
                            if (
                              value &&
                              (generalDetails.requestedBy ?? user.email) === value.email
                            ) {
                              setSnackBar({
                                type: 'error',
                                open: 'true',
                                message: 'You cant put yourself as second approver!',
                              })

                              setGeneralDetails((prevState) => ({
                                ...prevState,
                                approver: undefined,
                              }))

                              return
                            }
                            setGeneralDetails((prevState) => ({
                              ...prevState,
                              approver: value,
                              error_approver: undefined,
                            }))
                          }}
                          fetchOptions={(value) => fetchUsers(value)}
                          getOptionLabel={(option) =>
                            option.full_name
                              ? `${option.full_name} (${option.email})`
                              : ''
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.email === value.email
                          }
                          disabled={currentOrder !== 0}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          label="Detail of change and reason"
                          required={true}
                          multiline
                          maxRows={5}
                          value={generalDetails.changeSummary}
                          onChange={(value) => {
                            setGeneralDetails((prevState) => ({
                              ...prevState,
                              changeSummary: value.target.value,
                              error_changeSummary: undefined,
                            }))
                          }}
                          error={!!generalDetails.error_changeSummary}
                          helperText={
                            generalDetails.error_changeSummary ?? currentOrder === 0
                              ? `Press 'enter' for new line`
                              : ''
                          }
                          disabled={currentOrder !== 0}
                        />
                      </Grid>
                    </Grid>
                  </Accordion>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Accordion title={'Details'} expanded>
                    <POATable
                      style={{
                        transition: 'width 0.5s, height 0.5s',
                        height: `calc(100vh - 30px - 50px - 120px - ${
                          isChangeSummaryExpanded ? '300' : '110'
                        }px)`,
                      }}
                      handleEntityMenu={handleEntityMenu}
                      type={'edit'}
                      selectedCell={selectedCell}
                      setSelectedCell={setSelectedCell}
                      toEditCell={toEditCell}
                      setToEditCell={setToEditCell}
                      columns={columns}
                      serverPaginationResults={serverPaginationResult}
                      country={'SG'}
                      editable={currentOrder === 0}
                      currentPage={() => {
                        setServerPaginationResult((prevState) => {
                          return {
                            ...prevState,
                            currentPage: serverPaginationResult.currentPage,
                          }
                        })
                      }}
                      onClickToNextPage={() =>
                        setServerPaginationResult((prevState) => {
                          return {
                            ...prevState,
                            currentPage: serverPaginationResult.currentPage + 1,
                            toPreviousPage: serverPaginationResult.toPreviousPage + 1,
                            toNextPage: serverPaginationResult.toNextPage + 1,
                          }
                        })
                      }
                      onClickToPreviousPage={() =>
                        setServerPaginationResult((prevState) => {
                          return {
                            ...prevState,
                            currentPage: serverPaginationResult.currentPage - 1,
                            toPreviousPage: serverPaginationResult.toPreviousPage - 1,
                            toNextPage: serverPaginationResult.toNextPage - 1,
                          }
                        })
                      }
                      onClickToFirstPage={() =>
                        setServerPaginationResult((prevState) => {
                          return {
                            ...prevState,
                            currentPage: 1,
                            toPreviousPage: 0,
                            toNextPage: 2,
                          }
                        })
                      }
                      onClickToLastPage={() =>
                        setServerPaginationResult((prevState) => {
                          return {
                            ...prevState,
                            currentPage: serverPaginationResult.totalPages,
                            toPreviousPage: serverPaginationResult.currentPage - 1,
                          }
                        })
                      }
                    />
                  </Accordion>
                </Grid>
              </>
            )}
            {currentOrder === 99 && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <POATable
                  type={'edit'}
                  selectedCell={selectedCell}
                  setSelectedCell={setSelectedCell}
                  toEditCell={toEditCell}
                  setToEditCell={setToEditCell}
                  columns={columns}
                  serverPaginationResults={serverPaginationResult}
                  country={'SG'}
                  editable={editable && currentOrder === 0}
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                bottom: 0,
                pb: 1,
                display: 'flex',
                position: 'absolute',
              }}
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <Typography variant={'body2'} sx={{fontWeight: 600}} align={'left'}>
                  Legend:
                </Typography>
                <Stack direction={'row'} spacing={0} alignItems={'center'}>
                  <StopIcon fontSize={'medium'} style={{color: '#ff7171'}} />
                  <Typography variant={'caption'}>Delete Row</Typography>
                </Stack>
                <Stack direction={'row'} spacing={0} alignItems={'center'}>
                  <StopIcon fontSize={'medium'} style={{color: '#6ee1a8'}} />
                  <Typography variant={'caption'}>Add Row</Typography>
                </Stack>
                <Stack direction={'row'} spacing={0} alignItems={'center'}>
                  <StopIcon fontSize={'medium'} style={{color: '#ffff70'}} />
                  <Typography variant={'caption'}>
                    Edit Cell - Hover to view previous value
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        }
        sideDrawerContent={
          <Grid container direction={'row'} rowSpacing={2}>
            {requestId && (
              <Grid item xs={12}>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                >
                  <Button
                    type={'text'}
                    label={'Supporting Docs'}
                    onClick={() =>
                      setFullScreenDialogConst({open: true, type: 'supportingDoc'})
                    }
                  />
                  {getUserRole().role === HQ_ROLE_ID &&
                    ![99, 100, 101].includes(currentOrder) && (
                      <>
                        <IconButton
                          title={'HQ Settings'}
                          handleOnClick={(event) => setAnchorEl(event.currentTarget)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="table-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={() => setAnchorEl(null)}
                        >
                          <MenuItem
                            onClick={() => {
                              setAnchorEl(null)
                              setIsCallingApi({
                                loading: true,
                                type: 'withdraw',
                              })
                              setActionDialog((prevState) => ({
                                ...prevState,
                                type: 'Withdraw',
                                value: null,
                                open: true,
                              }))
                            }}
                          >
                            Override and Withdraw Ticket
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                </Stack>
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="subtitle1" align={'left'} sx={{color: '#6B6B6B'}}>
                General
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label={'Request ID'} value={requestId} disabled={true} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'Status'}
                InputProps={{
                  startAdornment: StatusChip(
                    currentOrder === 3 ? 'Pending 2nd Approver' : requestStatus
                  ),
                }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField label={'Country'} value={`${country} `} disabled={true} />{' '}
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'Requested By'}
                value={generalDetails.requestedBy}
                disabled={true}
              />{' '}
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'Last updated'}
                value={generalDetails.lastUpdatedOn}
                disabled={true}
              />
            </Grid>
            {requestId && (
              <>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" align={'left'} sx={{color: '#6B6B6B'}}>
                    Comment
                  </Typography>
                  <Typography variant="caption" align={'left'} sx={{color: '#6B6B6B'}}>
                    Input comment below, hover text for styling
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextBox
                    style={{
                      border: '1px solid #c7c7c7',
                      padding: '10px',
                      borderRadius: '5px',
                    }}
                    label={'Comments'}
                    customEditor={Editor}
                    value={commentField}
                    handleOnChange={(value) => setCommentField(value)}
                    placeholder={'Enter comment here'}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack direction={'row'} spacing={2} sx={{mt: 1, mb: 3}}>
                    <Button
                      label={'Post'}
                      onClick={() => addNewCommentToRequest.mutate(commentField)}
                      disabled={!commentField}
                    />
                  </Stack>
                </Grid>
                {renderComments()}
              </>
            )}
          </Grid>
        }
        collapseSideDrawer={[
          {
            icon: BookOnline,
            iconStyle: {transform: 'rotate(45deg)'},
            label: 'Request ID:',
            value: requestId,
          },
          {
            icon: ApprovalIcon,
            label: 'Status:',
            value: StatusChip(requestStatus),
          },
          {
            icon: Info,
            // label: 'Country - Segment - Entity:',
            // value: `${country} - ${segment} - ${generalDetails?.entityCode}`,
            label: 'Country:',
            value: `${country}`,
          },
          {
            icon: Face,
            label: 'Requested By:',
            value: generalDetails.requestedBy,
          },
          {
            icon: AccessTime,
            label: 'Last Updated On:',
            value: generalDetails.lastUpdatedOn
              ? moment.utc(generalDetails.lastUpdatedOn).local().format(dateTimeFormat)
              : '',
          },
          {
            icon: Comment,
            label: 'Comment Count:',
            value: comments.length,
          },
        ]}
      />
    </>
  )
}

export default withWidth()(Edit)
